module.exports = __webpack_public_path__ + "static/media/phoebe.65a71539.jpg";